import React from 'react';

const IconArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12.763" height="7.484" viewBox="0 0 12.763 7.484">
    <path data-name="Caminho 7610" d="M1.042,141.045l.186.186a.316.316,0,0,0,.448,0l5.155-5.155,5.155,5.155a.316.316,0,0,0,.448,0l.186-.186a.316.316,0,0,0,0-.447l-5.565-5.565a.316.316,0,0,0-.448,0L1.042,140.6A.316.316,0,0,0,1.042,141.045Z" transform="translate(13.213 141.874) rotate(180)" fill="none" stroke="#66647A" stroke-width="1"/>
  </svg>
);

export default IconArrow;
